export const SURF_PRESENTATION_TYPES = [
    "Educativo",
    "Informativo",
    "Executive",
    "Ispirazionale",
    "Persuasivo",
    "Operativo",
    "Posizionamento",
];
const SLIDE_RANGES = {
    Educativo: { min: 8, max: 10 },
    Informativo: { min: 6, max: 8 },
    Executive: { min: 4, max: 6 },
    Ispirazionale: { min: 5, max: 7 },
    Persuasivo: { min: 6, max: 8 },
    Operativo: { min: 7, max: 9 },
    Posizionamento: { min: 5, max: 7 },
};
export function slideRangeForPresentationType(type) {
    const key = String(type ?? "").trim();
    return SLIDE_RANGES[key] ?? { min: 6, max: 8 };
}
export function presentationTypeGuidance(type) {
    const range = slideRangeForPresentationType(type);
    const label = type?.trim() || "Generico";
    return (`Tipo presentazione: ${label}. ` +
        `Target ${range.min}–${range.max} slide. ` +
        `Adatta densità copy e profondità al tipo (Executive = sintetico; Educativo = didattico).`);
}
